import { getExceptionMap } from './helpers/getExceptionMap.js';
import { TreeNode } from "@/utils/va-order-test/testTree/TreeNode.js";
import _ from "lodash";

const exceptions = {
  namespaced: true,
  state: {
    exceptionMap: [],
  },
  mutations: {
    SET_EXCEPTION_MAP(state, exceptionMap) {
      state.exceptionMap = exceptionMap;
    },
  },
  actions: {
    async setExceptionMap({ commit, dispatch }, exceptions) {
      // change exception list to map
      let exceptionMap = getExceptionMap(exceptions);
      commit("SET_EXCEPTION_MAP", exceptionMap);
      dispatch("initException");
    },

    initException({ state, rootGetters, dispatch }) {
      let types = Object.keys(state.exceptionMap);
      types.forEach(type => {
        dispatch("setExceptionAndType", type);
      });
    },

    // create tree node and set parent and descendants
    // for link disable exception with itemName
    // current link disable tests are va Tests
    handleLinkDisableExceptionWithName({ state, dispatch, rootGetters }) {
      let id = -1;
      let exceptionTestList = [];
      state.exceptionMap["LINK_DISABLE"].filter(e => !e.itemId).forEach(exception => {
        let isExist = rootGetters["orderTest/tests/vaTestList"]
          .find(test => test.testName === exception.itemName);
        if (!isExist) {
          let newTest = {
            category: "va",
            id,
            isSelect: false,
            isSelectForXChooseY: false,
            isSelectForShortcut: false,
            isSelectForFavorite: false,
            isNotAllowedSelect: false,
            isNotAllowedSelectForShortcut: false,
            isNotAllowedSelectForFavorite: false,
            packageTests: rootGetters["orderTest/tests/vaTestList"]
              .filter(test => exception.affectedTestIdList.includes(test.id)),
            price: rootGetters["orderTest/tests/vaTestList"]
              .filter(test => exception.affectedTestIdList.includes(test.id))
              .map(test => test.price)
              .reduce((acc, price) => acc + price, 0),
            sampleTypeSets: {
              blood: new Set(),
              nonBlood: new Set(),
              dryIce: new Set()
            },
            type: "GROUP",
            testName: exception.itemName
          };
          exceptionTestList.push(newTest)
          exception.itemId = id; // let id be itemId fo link_didsable exception
          id--;
        }
      });

      exceptionTestList.forEach(exception => {
        let exceptionNode = new TreeNode(exception);
        if (exception.testName === "Testo, Free [Incl. Total, Albumin, SHBG]") {
          dispatch("setParentAndDescendants", { 
            node: exceptionNode, 
            parentId: 6, 
            descendantIds: [311, 313] 
          });
        }
        else if (exception.testName === "TIBC [Incl. UIBC and Iron]") {
          dispatch("setParentAndDescendants", { 
            node: exceptionNode, 
            parentId: 4, 
            descendantIds: [301, 302] 
          });
        }
        else if (exception.testName === "LDL Calculation"){
          dispatch("setParentAndDescendants", { 
            node: exceptionNode, 
            parentId: 9, 
            descendantIds: [321, 322, 359]
          });
        }
        dispatch("setSampleTypeSetsForExceptionNode", exceptionNode);
        dispatch("orderTest/tests/addVaTestNode", exceptionNode, { root: true });
      });
    },

    setParentAndDescendants({ rootState }, { node, parentId, descendantIds }) {
      // set parent to node with parentId
      let parent = rootState.orderTest.tests.vaBfsList.find(node => node.id === parentId);
      if (!parent) {
        return;
      }
      node.parent = parent;
      // add node to parent's descendants
      parent.descendants.push(node);
      // set descendants to nodes with descendantIds
      let descendants = rootState.orderTest.tests.vaBfsList
        .filter(node => descendantIds.includes(node.id));
      node.descendants = descendants;
      node.level = parent.level + 1;
      // set descendants's parent to node
      descendants.forEach(d => {
        // move itself from its parent's descendant List
        if (!d.parent) {
          return;
        }
        let index = d.parent.descendants.indexOf(d);
        if (index > -1) {
          d.parent.descendants.splice(index, 1);
        }
        d.parent = node;
        // reset its level to exceptionNode.level +1
        d.level = node.level + 1;
      });
    },

    // set sample type sets for fake exception nodes
    // get the types from the execption node's descendants
    setSampleTypeSetsForExceptionNode(_, node) {
      let sampleTypeSets = {
        blood: new Set(),
        nonBlood: new Set(),
        dryIce: new Set()
      };
      node.descendants.forEach(d => {
        let { blood, nonBlood, dryIce } = d.value.sampleTypeSets;
        sampleTypeSets.blood = new Set([...sampleTypeSets.blood, ...blood]);
        sampleTypeSets.nonBlood = new Set([...sampleTypeSets.nonBlood, ...nonBlood]);
        sampleTypeSets.dryIce = new Set([...sampleTypeSets.dryIce, ...dryIce]);
      });
      node.value.sampleTypeSets = sampleTypeSets;
    },

    setExceptionAndType({ state, rootGetters, rootState }, type) {
      if (type === "ONLOAD_DISABLE") {
        // handle onload disable exception
        state.exceptionMap[type].forEach(exception => {
          let exceptionTest = rootGetters["orderTest/tests/testList"]
            .find(t => t.id === exception.itemId);
          if (exceptionTest) {
            exceptionTest.isNotAllowedSelect = true;
            exceptionTest.isNotAllowedSelectForShortcut = true;
            exceptionTest.isNotAllowedSelectForFavorite = true;
            exceptionTest.isNotAllowedSelectForXChooseY = true;
          }
        });
      } else {
        state.exceptionMap[type].filter(e => e.itemId).forEach(exception => {
          let testIdList = exception.affectedTestIdList.concat(exception.itemId);
          let testList = rootGetters["orderTest/tests/testList"].filter(t => testIdList.includes(t.id));
          let bundleList = rootState.orderTest.panels.discountPanelList.filter(p => exception.affectedBundleIdList.includes(p.bundleId));
          testList.concat(bundleList).forEach(item => {
            item.isException = true;
            item.exceptionType ? item.exceptionType.push(type) : item.exceptionType = [type];
          })
        });
      }
    },
  }
};

export default exceptions;